import styles from "./Tag.module.scss";
import cn from "classnames";

interface TagProps {
  value: number;
  active?: boolean;
  disabled?: boolean;
}

export const Tag = ({
  value,
  active,
  disabled,
}: TagProps) => {
  if (!value) return null;

  return (
    <div
      className={cn(
        styles.tag,
        active && styles.active,
        disabled && styles.disabled,
      )}
    >
      {value > 99 ? "99+" : value}
    </div>
  );
};
